import { Box, Grid, Typography } from "@mui/material";
import { MunicipalTabulation, ProvincialCandidate, ProvincialDistrictTabulation, Tabulation, User } from "../../types";
import { collection, doc, getDoc, getDocs, orderBy, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";

import CandidateComparison from "./CandidateComparison";
import { db } from "../../firebase";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router";

interface ProvincialDistrictStatsProps {
  region: string;
  province: string;
  district: string;
  position: string;
}

const ProvincialDistrictStats: React.FC<ProvincialDistrictStatsProps> = ({ region, province, district, position }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [tabulation, setTabulation] = useState<ProvincialDistrictTabulation>();
  const [cityTabulations, setCityTabulations] = useState<Tabulation[]>([]);
  const [candidates, setCandidates] = useState<ProvincialCandidate[]>([]);

  const fetchProvincialDistrictTabulation = async (user: User) => {
    const docSnap = await getDoc(doc(db, `tabulationsV2/${user.dashboard}/regions/${region}/provinces/${province}/districts/${district}`));
    setTabulation(docSnap.data() as ProvincialDistrictTabulation);

    const citySnap = await getDocs(collection(db, `tabulationsV2/${user.dashboard}/regions/${region}/provinces/${province}/districts/${district}/cities`));
    setCityTabulations(citySnap.docs.map((d) => d.data() as MunicipalTabulation));

    const candidatesRef = collection(db, "candidates");
    const q = query(candidatesRef, 
      where("type", "==", "provincial"),
      where("province", "==", province),
      where("position", "==", position),
      orderBy("name", "asc")
    );
    const querySnapshot = await getDocs(q);
    const candidates = querySnapshot.docs.map(doc => doc.data() as ProvincialCandidate);
    setCandidates(candidates);
  };

  useEffect(() => {
    if (user) {
      fetchProvincialDistrictTabulation(user);
    }
  }, [user, province]);
  
  const onClick = (tabulation: MunicipalTabulation, position: string) => {
    navigate(`/dashboard/candidateStats?type=${tabulation.type}&position=${position}&region=${tabulation.region}&province=${tabulation.province}&district=${tabulation.district}&municipal=${tabulation.city_municipality}`);
  };

  return (
    <>
      {candidates.length > 0 && (
        <Box sx={{ flexGrow: 1, p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h4" gutterBottom align="center">
              {position} (Provincial Level)
            </Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {tabulation && (
                <CandidateComparison
                  tabulation={tabulation}
                  title={province}
                  position={position}
                  candidates={candidates}
                />
              )}
            </Grid>
            {cityTabulations.map((cityTabulation) => (
              <Grid item xs={12} md={6} key={cityTabulation.id}>
                <CandidateComparison
                  tabulation={cityTabulation}
                  title={cityTabulation.id}
                  position={position}
                  candidates={candidates}
                  onClick={() => onClick(cityTabulation as MunicipalTabulation, position)}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </>
  );
};

export default ProvincialDistrictStats;
